import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './DownloadApp.css';

function DownloadApp() {
  useStyles(s);

  return (
    <section id="download" className={s.download}>
      <div className={s.inner}>
        <div className={s.left}>
          <h2 className={s.title}>Download Our Mobile App</h2>
          <p className={s.text}>
            For lightning fast ordering experience, download the ASAP app and
            get food, groceries and more delivered straight to your door.
          </p>
          <div className={s.badges}>
            <a
              href="https://play.google.com/store/apps/details?id=com.asaplombokfood.eater"
              className={s.badge}
            >
              <span className={s.badgeIcon}>▶</span>
              <span>
                <span className={s.badgeSmall}>GET IT ON</span>
                <span className={s.badgeBig}>Google Play</span>
              </span>
            </a>
            <a
              href="https://apps.apple.com/id/app/asap-all-in-one-delivery-app/id6448992361"
              className={s.badge}
            >
              <span className={s.badgeIcon}>&#63743;</span>
              <span>
                <span className={s.badgeSmall}>Download on the</span>
                <span className={s.badgeBig}>App Store</span>
              </span>
            </a>
          </div>
        </div>
        <div className={s.right}>
          <img
            src="https://picsum.photos/seed/asap-app/680/760"
            alt="ASAP mobile app"
          />
        </div>
      </div>
    </section>
  );
}

export default DownloadApp;
